import Axios from "../../../Lib/Axios";
import Endpoint from "../../../Config/Endpoint";

export const fetchDataList = async (params = '', page = 1) => {

    try {
        return await Axios.get(Endpoint.movies.list+page, {params}).then(function (response) {
           return response;
        }).catch(function (error) {
            return error.response;
        });

    } catch (error) {
        return error.response;
    }
}


export const fetchPopulars = async (params = '', page = 1) => {

    try {
        return await Axios.get(Endpoint.movies.popular+page, {params}).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });

    } catch (error) {
        return error.response;
    }
}

export const fetchMovieDetail = async (alias) => {

    try {
        return await Axios.get(Endpoint.movies.detall+alias).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });

    } catch (error) {
        return error.response;
    }
}

export const updateLikeMovie = async (slug, status) => {

    try {
        return await Axios.get(Endpoint.movies.like+slug+'/'+status, {loading: false}).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });

    } catch (error) {
        return error.response;
    }
}

export const playVideo = async (id) => {
    try {
        return await Axios.get(Endpoint.movies.view+id, {loading: false}).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });

    } catch (error) {
        return error.response;
    }
}

export const fetchVideoIframe = async (alias) => {

    try {
        return await Axios.get(Endpoint.movies.iframeVideo+alias).then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });

    } catch (error) {
        return error.response;
    }
}